export const mainGoldFont = {
  dropShadow: true,
  dropShadowAngle: 1.6,
  dropShadowAlpha: 0.5,
  fill: [
    "#feff00",
    "#feffe8",
    "#feff00",
    "#ff7800"
  ],
  fillGradientStops: [
    0.2,
    0.5,
    0.7
  ],
  lineJoin: "round",
  miterLimit: 0,
  stroke: "#700000",
  strokeThickness: 5,
  whiteSpace: "normal"
};

export const secondGoldFont = {
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.6,
  fill: [
    "#fdf226",
    "#ffffb8",
    "#fff424",
    "#fff424",
    "#ff8e09"
  ],
  fillGradientStops: [
    0.1,
    0.28,
    0.5,
    0.6,
    0.77
  ],
  lineJoin: "round",
  miterLimit: 0,
  whiteSpace: "normal"
};
export const titleGoldFont = {
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.6,
  fill: [
    "#fdff21",
    "#ffffea",
    "#ffff00",
    "#ff8e09",
    "#ffff00",
    "#ffff00"
  ],
  fillGradientStops: [
    0.1,
    0.4,
    0.6,
    0.63,
    0.9,
    0.93
  ],
  lineJoin: "round",
  miterLimit: 0,
  whiteSpace: "normal"
};

export const freespinsPopupsFont = {
  dropShadow: true,
  dropShadowAlpha: 0.3,
  dropShadowAngle: 1.6,
  dropShadowBlur: 4,
  dropShadowDistance: 4,
  fill: [
    "#feff26",
    "#ffffeb",
    "#feff00",
    "#fd8002",
    "#feff00",
    "#feff00"
  ],
  fillGradientStops: [
    0.2,
    0.5,
    0.65,
    0.75,
    0.8
  ],
  fontFamily: 'UbuntuBold',
  lineJoin: "round",
  miterLimit: 0,
  stroke: "#ff4029",
  strokeThickness: 5,
  whiteSpace: "normal"
};

export const jackpotValues = {
  dropShadow: true,
  dropShadowAlpha: 0.4,
  dropShadowAngle: 1.6,
  dropShadowDistance: 8,
  fill: 'white',
  lineJoin: 'round',
  miterLimit: 0,
  strokeThickness: 8,
  whiteSpace: 'normal'
};

export const jackpotStrokes = {
  0: { stroke: '#cc3300', strokeThickness: 5 },
  1: { stroke: '#990000', strokeThickness: 5 },
  2: { stroke: '#336600', strokeThickness: 5 },
};

export const amountYellowFont = {
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.6,
  fill: [
    "#fdff21",
    "#fde044",
    "#ffff9d",
    "#fff357",
    "#fff609",
    "#e2a208",
    "#fad944"
  ],
  fillGradientStops: [
    0,
    0.2,
    0.4,
    0.5,
    0.65,
    0.8,
    0.9
  ],
  lineJoin: "round",
  miterLimit: 0,
  whiteSpace: "normal"
}
